<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;"></template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-select v-model="query.pid" placeholder="请选择招聘计划" style="width:250px;" @change="doQuery">
                                <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="query.state" placeholder="请选择支付状态" style="width:150px;" @change="doQuery">
                                <el-option label="支付成功" value="Success"></el-option>
                                <el-option label="已退款" value="Refund"></el-option>
                                <el-option label="支付中" value="Wait"></el-option>
                                <el-option label="支付失败" value="Error"></el-option>
                                <el-option label="支付取消" value="Cancel"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item>
                            <el-select v-model="query.biz" placeholder="请选择业务类型" style="width:150px;" @change="doQuery">
                                <el-option label="报名费" value="Reg"></el-option>
                                <el-option label="信息费" value="Forget"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item>
                            <el-input v-model="query.id" clearable placeholder="支付单号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.sno" v-if="query.biz != 'Forget'" clearable placeholder="报名序号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.idno" v-if="query.biz != 'Forget'" clearable placeholder="身份证号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" style="width: 100%">
                <el-table-column show-overflow-tooltip label="支付单号">
                    <template slot-scope="scope">
                        <p>
                            {{ scope.row.id }}
                            [
                            <span style="  color: chocolate;">{{ scope.row.cnl === 'WXPAY' ? '微信扫码' : '支付宝扫码' }}</span>
                            ]
                        </p>
                        <p>
                            <template v-if="scope.row.refund">
                                <el-tag type="danger">已退款</el-tag>
                                {{ scope.row.ramt }} / {{ scope.row.rtime }}
                            </template>
                            <template v-else>
                                <el-tag size="mini" type="success" v-if="scope.row.state === 'Success'">支付完成</el-tag>
                                <el-tag size="mini" type="info" v-if="scope.row.state === 'Wait'">支付完成</el-tag>
                                <el-tag size="mini" type="warning" v-if="scope.row.state === 'Error'">支付失败</el-tag>
                                <el-tag size="mini" type="warning" v-if="scope.row.state === 'Cancel'">支付取消</el-tag>
                            </template>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="支付信息">
                    <template slot-scope="scope">
                        <b>￥{{ scope.row.amt }}</b>
                        <span style="margin-left: 10px;">{{ scope.row.info }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招聘信息">
                    <template slot-scope="scope">
                        <p>[{{ scope.row.plan.bno }}] {{ scope.row.plan.name }}</p>
                        <p>
                            {{ scope.row.post.unit }}
                            <span style="color: darkorange;">[{{ scope.row.post.code }}] {{ scope.row.post.name }}</span>
                        </p>
                    </template>
                </el-table-column>

                <el-table-column show-overflow-tooltip label="考生信息">
                    <template slot-scope="scope">
                        <p>{{ scope.row.reg.name }} [{{ scope.row.reg.sno }}]</p>
                        <p>{{ scope.row.reg.idno }} / {{ scope.row.reg.mob }}</p>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
    </div>
</template>

<script>
const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    id: '',
    pid: '',
    idno: '',
    sno: '',
    state: '',
    biz: 'Reg'
}
export default {
    name: 'RegPbill',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            unit: []
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['招聘管理', '缴费信息'])
        this.init()
    },
    methods: {
        init() {
            this.doLoadPlan()
            this.doLoad()
        },
        doLoadPlan() {
            this.$http
                .get('/comm/data/plan/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.plans = result.datas
                })
        },
        doLoad() {
            this.tableLoading = true
            if (this.query.biz === 'Forget') {
                this.query.sno = ''
                this.query.idno = ''
            }
            this.$http
                .get('/ops/finance/payment/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        }
    }
}
</script>
